// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"g1-z","displaySixCardTiles":"h1-z"};